// Build a Google Maps search URL for a property address.
// Opens at the address with the standard map pin + sidebar.
export function googleMapsUrl(address) {
  if (!address) return null
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
}
